import React, { FunctionComponent } from "react";

import { IActionHistoryTable, selectedRowStyles, Table } from ".";
import { LayoutContainer } from "../../components/layout/LayoutContainer";
import { TABLE_THEMES } from "../../components/tables/themes";
import { BulkAction } from "../../generated/graphql.generated";
import { useGetRiskActionHistoryActiveQuery } from "../../operations/risks/queries/getRiskActionHistoryActive.generated";
import { usePollPaginatedTableList } from "../../utils/table/pollPaginatedTableList";
import { usePaginatedTableData } from "../../utils/table/usePaginatedTableData";
import { usePaginatedTableState } from "../../utils/table/useTableState";
import { columnsWithCancel } from "../BulkActions/columns";

export const BulkActionHistoryTableActive: FunctionComponent<
  IActionHistoryTable
> = ({ className, onRowClick, selectedRowId }) => {
  const [tableState, setTableState] = usePaginatedTableState({
    cursor: "",
    shouldShowFullLoader: true,
    limit: 10,
  });

  const [result, executeQuery] = useGetRiskActionHistoryActiveQuery({
    variables: {
      cursor: tableState.cursor,
      limit: tableState.limit,
    },
    requestPolicy: "cache-and-network",
  });

  const { rows, hasNextPage, endCursor } = usePaginatedTableData({
    data: result.data?.listActiveBulkActions,
    transformer: (data) =>
      data?.edges?.map((edge) => {
        const node = edge?.node;

        return {
          ...(node as BulkAction),
        };
      }) || [],
  });

  usePollPaginatedTableList({
    tableStateGetterSetter: [tableState, setTableState],
    initialPageSize: 10,
    numberOfResults: rows.length,
    frequency: 5000,
    runQuery: executeQuery,
  });

  return (
    <Table
      heading="Active actions"
      theme={TABLE_THEMES.SPACED_HEADER_ROW_TABLE}
      tableLoading={result.fetching && tableState.shouldShowFullLoader}
      buttonLoading={result.fetching}
      columns={columnsWithCancel}
      data={rows}
      hasNextPage={hasNextPage}
      selectedRowId={selectedRowId}
      themeOverrides={selectedRowStyles}
      onNextPage={() => {
        setTableState((s) => ({
          ...s,
          cursor: endCursor,
          limit: 5,
          shouldShowFullLoader: false,
        }));
      }}
      useExternalContext={false}
      noResults={
        <LayoutContainer fontSize="xsm" px={3} pb={3}>
          There are currently no active actions
        </LayoutContainer>
      }
      onRowClick={onRowClick}
    />
  );
};
